/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';

import { InjectedReducersType } from 'utils/types/injector-typings';
import toastReducer from './toast/toastSlice';
import authReducer from './auth/authSlice';
import ClientManagementReducer from './client/clientSlice';
import ManagerManagementReducer from './manager/managerSlice';
import EmployeeManagementReducer from './employee/employeeSlice';
import ComManagementReducer from './com/comSlice';
import InterviewerManagementReducer from './interviewer/interviewerSlice';
import ImplementReducer from './implements/implementsSlice';
import AdditionalInterviewReducer from './additionalInterview/additionalInterviewSlice';
import { OmoteuraReducer } from './omoteura/omoteuraSlice';
import { ConsultantInterviewReducer } from './consultantInterview/consultantInterview';
import CareerMemoManagementReducer from './careerMemo/careerMemoSlice';
import AnalysisReducer from './analysis/analysisSlice';
import EmployeeWebReducer from './employeeWeb/employeeWebSlice';
import SurveyReducer from './survey/surveySlice';
import SurveyProgressReducer from './surveyProgress/surveyProgressSlice';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export const rootReducers = {
  auth: authReducer,
  toast: toastReducer,
  client: ClientManagementReducer,
  manager: ManagerManagementReducer,
  interviewer: InterviewerManagementReducer,
  employee: EmployeeManagementReducer,
  com: ComManagementReducer,
  implement: ImplementReducer,
  additionalInterview: AdditionalInterviewReducer,
  omoteura: OmoteuraReducer,
  consultantInterview: ConsultantInterviewReducer,
  careerMemo: CareerMemoManagementReducer,
  analysis: AnalysisReducer,
  employeeWeb: EmployeeWebReducer,
  survey: SurveyReducer,
  surveyProgress: SurveyProgressReducer,
};
export function createReducer(injectedReducers: InjectedReducersType = {}) {
  // Initially we don't have any injectedReducers, so returning identity function to avoid the error
  if (Object.keys(injectedReducers).length === 0) {
    return (state: any) => state;
  } else {
    return combineReducers({
      ...injectedReducers,
    });
  }
}
